import checkTypeValidity from '../type-check/check-type-validity.js';
import validListProp from './valid-list-prop.js';

/**
 * @func sortNumerically
 * @param {array} list - Array of objects to be sorted.
 * @param {string} prop - key where function can find number to sort by
 * @param {string} direction - optional param tells function to sort ascending or descending.
 * Defaults to ascending
 * @return {array}
 * @desc Sorts an array of objects numerically.
 * ```js
 * const myList = [{value: 10}, {value: 7}, {value: 17}]
 * sortNumerically(myList, 'value', 'desc');
 * // returns [{value: 17}, {value: 10}, {value: 7}]
 * ```
 * @memberof module:Array
 * @instance
 */
function sortNumerically(list, prop, direction) {
    if (!checkTypeValidity(['arrayOfObjects'], list))
        return [];
    if (!prop || !validListProp(list, prop))
        return list;
    if (direction === 'desc') {
        return list.sort((a, b) => (a[prop] < b[prop] ? 1 : -1));
    }
    else {
        return list.sort((a, b) => (a[prop] > b[prop] ? 1 : -1));
    }
}

export { sortNumerically as default };
